module.exports = __webpack_public_path__ + "media/images/home/icon-floorplan-529f0aee5b2bdd18ef0ee76324c4bb31.png";